import { render, staticRenderFns } from "./BuhinDetail.vue?vue&type=template&id=abf588e2&scoped=true&"
import script from "./BuhinDetail.vue?vue&type=script&lang=ts&"
export * from "./BuhinDetail.vue?vue&type=script&lang=ts&"
import style0 from "./BuhinDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BuhinDetail.vue?vue&type=style&index=1&id=abf588e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf588e2",
  null
  
)

component.options.__file = "BuhinDetail.vue"
export default component.exports